import { RECHARGE_REPORT_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = {};

export default function rechargeReport(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case RECHARGE_REPORT_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
